<template>
    <div class="section-box">
        <el-row type="flex" class="row-bg" justify="end" v-if="!(typeof(actionData.systemgngl_add) != 'undefined'&&!actionData.systemgngl_add)">
            <el-col :span="24" style="text-align: right;">
                <el-button size="medium" type="primary" icon="el-icon-plus" @click="onAddFunction">添加</el-button>
            </el-col>
        </el-row>
        <el-form inline label-width="120px">
            <el-form-item label="控制器名称：">
                <el-input size="medium" placeholder="输入关键字搜索" v-model="form.ControllerName" type="text" />
            </el-form-item>
            <el-form-item>
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-form-item>
        </el-form>

        <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%;margin-top: 20px;"
            height="590"
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="功能编号" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.ActionID || '--'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="功能名称" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.ActionName || '--'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="控制器名称" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.ControllerName || '--'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="功能描述" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.Description || '--'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="备注" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.Remark || '--'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <template v-if="!(typeof(actionData.systemgngl_edit) != 'undefined'&&!actionData.systemgngl_edit)">
                        <el-button size="mini" type="primary" @click="onEditFunction(scope.row)">编辑</el-button>
                    </template>
                    <template v-if="!(typeof(actionData.systemgngl_delete) != 'undefined'&&!actionData.systemgngl_delete)">
                        <el-button size="mini" type="danger" @click="deleteActionFunction(scope.row.ActionID)">删除</el-button>
                    </template>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageIndex"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="30%"
        >
            <el-form label-width="120px">
                <el-form-item label="菜单：" required>
                    <el-select size="medium" filterable placeholder="请选择菜单" v-model="infoForm.MenuID" style="width: 100%">
                        <el-option 
                            v-for="(item,index) in menuList" 
                            :label="item.MenuName" 
                            :value="item.MenuID" 
                            :key="index"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="控制器名称：" required>
                    <el-input size="medium" placeholder="请输入控制器名称" v-model="infoForm.ControllerName" type="text" />
                </el-form-item>
                <el-form-item label="功能名称：" required>
                    <el-input size="medium" placeholder="请输入功能名称" v-model="infoForm.ActionName" type="text" />
                </el-form-item>
                <el-form-item label="功能描述：" required>
                    <el-input size="medium" placeholder="请输入功能描述" v-model="infoForm.Description" type="text" />
                </el-form-item>
                <el-form-item label="备注：" >
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 2 }"
                        placeholder="请输入内容"
                        v-model="infoForm.Remark">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="medium" @click="confirmSetFunction()" :loading="confirmLoading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import {
        managerActionList,              //获取功能列表
        functionListMenu,               //获取功能菜单 在dialog里
        setAction,                      //新增或编辑 确定提交 在dialog 里
        deleteAction,                   //删除功能列表
    } from "@/service/system";
    import { getActionData } from '@/utils/store'
    export default {
        data() {
            return {
                actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用
                dialogTitle: '添加或编辑',
                dialogVisible: false,
                listLoading: false,
                confirmLoading: false,
                form: {
                    PageIndex: 1,
                    PageSize: 10,
                    ControllerName: '',
                },
                searchData:{},
                oraginForm:{},
                total: 0,                       //总条数
                tableData:[],

                infoForm: {
                    ActionID: '',               //功能id 编辑的时候用
                    ActionName: '',             //功能名称
                    ControllerName: '',         //控制器名称
                    Description: '',            //功能描述
                    Remark: '',                 //备注
                    MenuID: '',                 //菜单id
                    ActionCode: '',             //功能代码
                    AppId: 1,                   //旧0 新1 后台
                },
                oraginInfoForm: {},
                menuList:[],                    //dialog 菜单
            };
        },
        activated(){
            this.handleSearch()
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.oraginInfoForm = JSON.parse(JSON.stringify(this.infoForm))
            this.tableData = [];
        },
        methods: {
            // 查询
            handleSearch() {
                this.searchData = Object.assign({}, this.form)
                this.handleCurrentChange(1)
            },
            // 重置
            handleReset() {
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
                this.handleSearch()
            },
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.PageIndex = 1
                this.form.PageSize = val
                this.searchData.PageIndex = 1
                this.searchData.PageSize = val
                this.GetManagerActionList()
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.PageIndex = val
                this.searchData.PageIndex = val
                this.GetManagerActionList()
            },
            //获取功能列表
            async GetManagerActionList(){
                this.listLoading = true
                let data = JSON.parse(JSON.stringify(this.searchData))
                !data.ControllerName && delete data.ControllerName
                data.AppId = 1
                data.platform = 'pcweb'
                let res = await managerActionList(data)
                this.listLoading = false
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.tableData = res.Data.List
                this.total = res.Data.TotalRows
            },
            //点击添加
            onAddFunction(){
                this.dialogTitle = '添加'
                this.dialogVisible = true;
                this.GetFunctionListMenu();
                this.infoForm = JSON.parse(JSON.stringify(this.oraginInfoForm))
            },
            // 获取功能菜单列表
            async GetFunctionListMenu(){
                let data = {}
                data.AppId = 1;
                data.platform = 'pcweb'
                let res = await functionListMenu(data)
                this.menuList = res.Data.List
            },
            //dialog 确定提交
            confirmSetFunction(){
                let data = Object.assign({}, this.infoForm)
                if(!data.MenuID) {
                    return this.$message.warning('请选择菜单')
                }
                if(!data.ControllerName) {
                    return this.$message.warning('请输入控制器名称')
                }
                if(!data.ActionName) {
                    return this.$message.warning('请输入功能名称')
                }
                if(!data.Description) {
                    return this.$message.warning('请输入功能描述')
                }
                !data.ActionID && delete data.ActionID
                !data.ActionCode && delete data.ActionCode
                data.platform = 'pcweb'
                this.confirmLoading = true
                setAction(data).then(res=> {
                    this.confirmLoading = false
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success(res.Message)
                    this.dialogVisible = false
                    this.GetManagerActionList();
                })
            },
            // 点击list 编辑
            onEditFunction(row){
                let infoForm = JSON.parse(JSON.stringify(row))
                this.dialogTitle = '编辑'
                this.dialogVisible = true;
                this.GetFunctionListMenu();
                this.$nextTick(()=>{
                    this.infoForm = infoForm
                })
            },
            // 删除功能列表
            deleteActionFunction(id){
                let data = {}
                data.ActionID = id
                data.platform = 'pcweb'
                deleteAction(data).then(res=>{
                    if(res.Result !=1 ) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success(res.Message)
                    this.GetManagerActionList();
                })
            },
        }
    };
</script>
<style lang="scss">
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }
    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
</style>